<div class="documents-dialog" *ngIf="active">
  <div class="documents-dialog__content">
    <button class="documents-dialog__content__close" (click)="closeDialog()">
      <span class="material-icons">close</span>Close
    </button>
    <h2>Submit Bid?</h2>

    <ng-container>
      <div class="">
        <div class="mb-10">
          Clicking “Submit Bid” will send project for review. <br /><br />
          Do you wish to continue?
        </div>
        <requirements-acknowledgement
          #reqAck
          [projectRequirements]="data.specialQuoteRequirements"
          [siteRequirements]="data.sites?.[0]?.site?.specialSiteCondition"
          [showSite]="true">
        </requirements-acknowledgement>
        <br />
        <div class="container mt-30">
          <div class="column column-left">
            <div class="documents-dialog__content__footer__service-type">
              <p class="documents-dialog__content__footer__service-type__label">
                Project
              </p>
              <p class="service-type">
                {{
                    "Project ID: " +
                    data.projectOrderId
                }}
              </p>
            </div>
          </div>
          <div class="right-columns panelfields">
            <div class="column">
              <button
                type="submit"
                class="btn btn-primary"
                (click)="submit()"
                [disabled]="isSubmitting || (reqAck.requiresAcknowledgement && !reqAck.acknowledged)">
                Submit Bid
              </button>
            </div>
            <div class="column">
              <button
                type="submit"
                class="btn btn-default"
                (click)="closeDialog()"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="documents-dialog__background" (click)="closeDialog()"></div>
</div>
<bidsubmitted-dialog
  [active]="bidSubmittedActive"
  (modalClosed)="toggleCloseSubmittedBidModal()"
  [ngClass]="{ 'documents-dialog--active': bidSubmittedActive }"
></bidsubmitted-dialog>
